import { domain } from '@/utils/env';
/**
 * Due to some security issues, so verification code must be used in correct place.
 * So 1 code to 1 behavior is needed here.
 *
 * Used in some apis where it will send verification code.
 *    - send mail verification code
 *    - send phone verification code
 */

// email register and code verification.
export const SECURITY_MAIL_REG_AND_VERIFY = 1;

// using email to bind google 2FA and code verification.
export const SECURITY_MAIL_2FA_AND_VERIFY = 2;

// using email to bind phone and code verification.
export const SECURITY_MAIL_BIND_PHONE_AND_VERIFY = 3;

// forget email password
export const SECURITY_MAIL_FORGET_PWD = 4;

// phone register and code verification.
export const SECURITY_PHONE_REG_AND_VERIFY = 5;

// using phone to bind google 2FA and code verification.
export const SECURITY_PHONE_2FA_AND_VERIFY = 6;

// using phone to bind email and code verification.
export const SECURITY_PHONE_BIND_MAIL_AND_VERIFY = 7;

// using close new address fetch coin
export const SECURITY_CLOSE_NEW_ADDRESS_AND_VERIFY = 21;

// using close only address book fetch coin
export const SECURITY_CLOSE_ONLY_ADDRESS_BOOK_AND_VERIFY = 22;

// using close all address fetch coin
export const SECURITY_CLOSE_ALL_FETCH_COIN_AND_VERIFY = 23;

// forget phone password
export const SECURITY_PHONE_FORGET_PWD = 8;

// using email to set or update anti_phishing_code and code verification.
export const SECURITY_MAIL_ANTI_PHISHING_CODE_AND_VERIFY = 14;

// using email to bind phone and code verification.
export const FROM_YUBIKEY_REGISTRATION = 27;

// 封禁国家
export const BAN_COUNTRY_CODES = ['CN'];

// child account register and code verification.
export const SECURITY_MAIL_CHILD_REG_AND_VERIFY = 1;

// child account register and code verification.
export const SECURITY_PHONE_CHILD_REG_AND_VERIFY = 5;
// 通过错误码展示手机号错误
export const BAN_COUNTRY_ERROR_CODES = [31018];

// 提币地址是否需要加tag，来判断是否是交易所的地址

export const ADDRESS_IS_EXCHANGE = ['XRP', 'EOS'];

// 20095地址校验错误

export const CHECK_ADDRESS_IS_EXCHANGE = 20095;

// qq行为验证appid更改
// bybit域名使用v2，其他域名使用v1，后端v1并没有使用只是便于理解。
export const notUseNewVersions = ['bybit'];
export const KEY_VERSION = notUseNewVersions.includes(domain) ? 'v2' : 'v1';

// 解绑邮箱发送邮箱验证码
export const UNBIND_EMAIL_FROM = 33;

// 解绑邮箱发送手机验证码
export const UNBIND_PHONE_FROM = 37;

// 换绑新邮箱发送邮箱验证码
export const CHANGE_EMAIL_NEW_FROM = 34;

// 换绑老邮箱发送邮箱验证码
export const CHANGE_EMAIL_OLD_FROM = 35;

// 换绑发送手机验证码
export const CHANGE_EMAIL_PHONE_FROM = 36;

// 修改手机号新手机号发送验证码
export const CHANGE_MOBILE_NEW_CODE_FROM = 38;

// 修改手机号老手机号发送验证码
export const CHANGE_MOBILE_OLD_CODE_FROM = 39;

// 修改手机号发送邮箱验证码
export const CHANGE_MOBILE_EMAIL_FROM = 40;

// oauth admin 后台管理重置密钥邮箱验证码
export const OAUTH_ADMIN_RESET_SECRET_EMAIL_FROM = 26;
